(() => {
  const mobile = window.matchMedia('(max-width: 989px)');
  const viewport = window.visualViewport;
  let frame = 0;
  let bar;
  const sync = () => {
    frame = 0;
    if (!mobile.matches) {
      document.body.style.removeProperty('--cb-teaser-clearance');
      return;
    }
    const viewportBottom = viewport ? Math.min(window.innerHeight, viewport.offsetTop + viewport.height) : window.innerHeight;
    const viewportGap = Math.max(0, window.innerHeight - viewportBottom);
    const productPage = document.body.classList.contains('body-template-product');
    let clearance = viewportGap + (productPage ? 140 : 0);
    if (bar && getComputedStyle(bar).position === 'fixed') {
      const rect = bar.getBoundingClientRect();
      const bottom = Math.max(viewportGap, parseFloat(getComputedStyle(bar).bottom) || 0);
      if (rect.height > 0 && rect.width > 0) clearance = Math.max(clearance, bottom + rect.height);
      else if (document.body.classList.contains('body-template-product')) clearance = viewportGap + 140;
    }
    const value = Math.ceil(clearance) + 'px';
    if (document.body.style.getPropertyValue('--cb-teaser-clearance') !== value) {
      document.body.style.setProperty('--cb-teaser-clearance', value);
    }
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(sync);
  };
  const resized = new ResizeObserver(schedule);
  const findBar = () => {
    const next = document.querySelector('.product-sticky-bar');
    if (next !== bar) {
      if (bar) resized.unobserve(bar);
      bar = next;
      if (bar) resized.observe(bar);
    }
    schedule();
  };
  if (document.body.classList.contains('body-template-product')) {
    new MutationObserver(findBar).observe(document.body, { childList: true, subtree: true });
  }
  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  viewport?.addEventListener('resize', schedule, { passive: true });
  viewport?.addEventListener('scroll', schedule, { passive: true });
  document.addEventListener('DOMContentLoaded', findBar, { once: true });
  document.addEventListener('shopify:section:load', findBar);
  findBar();
  sync();
})();



